/**
 * ScheduleSelector component helps to schedule Daily, Weekly, Monthly and Yearly backups.
 * It takes cares of the "schedule" part of the output JSON
 *

OUTPUT FORMAT:
URL: '/hybridity/api/dps/vdc/'+vdcId+'/vapp/'+vappId+'/policy'
Method: POST for Apply and PUT for Edit.

1. DAILY
{
  "dataset": {
    "entities": null,
    "containers": null
  },
  "retention": {
    "days": "7"
  },
  "schedule": {
    "scheduleType": "Daily",
    "timeZone": "Pacific/Rarotonga",
    "startTime": "00:00:00",
    "endTime": ""
  }
}

2. WEEKLY
{
  "dataset": {
    "entities": null,
    "containers": null
  },
  "retention": {
    "days": "6"
  },
  "schedule": {
    "scheduleType": "Weekly",
    "timeZone": "Pacific/Niue",
    "startTime": "00:00:00",
    "endTime": "",
    "days": [
      "Monday"
    ]
  }
}

3. MONTHLY
{
  "dataset": {
    "entities": null,
    "containers": null
  },
  "retention": {
    "days": "7"
  },
  "schedule": {
    "scheduleType": "Monthly",
    "timeZone": "Pacific/Rarotonga",
    "startTime": "21:05:00",
    "endTime": "",
    "dates": [
      8
    ]
  }
}

4. YEARLY
{
  "dataset": {
    "entities": null,
    "containers": null
  },
  "retention": {
    "days": "100"
  },
  "schedule": {
    "scheduleType": "Yearly",
    "timeZone": "Asia/Calcutta",
    "startTime": "21:05:00",
    "endTime": "",
    "months": [
      "April"
    ],
    "dates": [
      17
    ]
  }
}
*/

import { Component, OnInit, forwardRef, Input, OnChanges } from '@angular/core';
import { FormControl, ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { findObjectIndexInArray } from '../utils';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
const _ = require('lodash');

export function isValidMonthDateCombinations(monthsArray, datesArray): boolean {
  let valid: boolean = false;
  let d = undefined;
  let year = new Date().getFullYear();
  let months = {
    "January": 0,
    "February": 1,
    "March": 2,
    "April": 3,
    "May": 4,
    "June": 5,
    "July": 6,
    "August": 7,
    "September": 8,
    "October": 9,
    "November": 10,
    "December": 11
  };

  if( monthsArray.constructor === Array && monthsArray.length > 0 &&
      datesArray.constructor === Array && datesArray.length === 1 ) {
        for(let x = 0; x < monthsArray.length; x++) {
          d = new Date(monthsArray[x] + ' ' + datesArray[0] + ' ' + year);
          if (d.getMonth() == months[monthsArray[x]] && d.getDate() == datesArray[0]) {
              valid = true;
          }
          else {
            valid = false;
            break;
          }
        }
  }
  return valid;
}

//custom validator
export function scheduleValidator(schedule, FREQUENCY_CONSTANTS, alertObject, translateService) {
  return (c: FormControl) => {
    let err = {
      scheduleError: {
        reason: "schedule object is not valid"
      }
    };

  let isScheduleValid = false;
  alertObject.isShown = false;
  alertObject.msg = "";
  alertObject.alertType = 'alert-danger';
  if (schedule && schedule.scheduleType && schedule.startTime && schedule.startTime != '' && schedule.timeZone && schedule.timeZone) {
    switch(schedule.scheduleType){
      case FREQUENCY_CONSTANTS.DAILY:
        isScheduleValid = true;
        if(schedule.hasOwnProperty('days'))
          delete schedule.days;
        if(schedule.hasOwnProperty('dates'))
          delete schedule.dates;
        if(schedule.hasOwnProperty('months'))
          delete schedule.months;
        break;
      case FREQUENCY_CONSTANTS.WEEKLY:
        if(schedule.days && schedule.days.constructor === Array && schedule.days.length > 0)
          isScheduleValid = true;
        if(schedule.hasOwnProperty('dates'))
          delete schedule.dates;
        if(schedule.hasOwnProperty('months'))
          delete schedule.months;
        break;
      case FREQUENCY_CONSTANTS.MONTHLY:
        if(schedule.dates && schedule.dates.constructor === Array && schedule.dates.length > 0) {
          var isScheduleValidError = false;
          var isScheduleValidWarning = false;
          for(let i = 0; i < schedule.dates.length; i++) {
            // check if error
            if ( isNaN(schedule.dates[i]) || ( schedule.dates[i] < 1 || schedule.dates[i] > 31 ) ) {
              isScheduleValidError = true;
              break;
            }
            // check if warning
            if( schedule.dates[i] > 28 ) {
              if(schedule.dates[i] == 31) {
                alertObject.msg = translateService.instant('dpsModule.scheduleSelector.messages.warning31stDay');
              } else if(schedule.dates[i] == 29) {
                alertObject.msg = translateService.instant('dpsModule.scheduleSelector.messages.warning29thDay');
              } else {
                alertObject.msg = translateService.instant('dpsModule.scheduleSelector.messages.warning30thDay');
              }
              isScheduleValidWarning = true;
            }
          }

          if ( isScheduleValidError ) {
            alertObject.isShown = true;
            alertObject.alertType = 'alert-danger';
            alertObject.msg = translateService.instant('dpsModule.scheduleSelector.messages.invalidMonthDate');
            isScheduleValid = false;
          } else {
            if ( isScheduleValidWarning ) {
              alertObject.isShown = true;
              alertObject.alertType = 'alert-warning';
            }
            isScheduleValid = true;
          }

        }
        if(schedule.hasOwnProperty('days'))
          delete schedule.days;
        if(schedule.hasOwnProperty('months'))
          delete schedule.months;
        break;
      case FREQUENCY_CONSTANTS.YEARLY:
        if(schedule.months && schedule.months.constructor === Array && schedule.months.length > 0
          && schedule.dates && schedule.dates.constructor === Array && schedule.dates.length > 0) {

            for(let i = 0; i < schedule.dates.length; i++) {
              // check if error
              if ( isNaN(schedule.dates[i]) || ( schedule.dates[i] < 1 || schedule.dates[i] > 31 ) ) {
                isScheduleValid = false;
                break;
              } else {
                isScheduleValid = isValidMonthDateCombinations( schedule.months, [schedule.dates[i]] );
                if (!isScheduleValid) { break; }
              }
            }

            if(!isScheduleValid) {
              alertObject.isShown = true;
              alertObject.alertType = 'alert-danger';
              alertObject.msg = translateService.instant('dpsModule.scheduleSelector.messages.invalidMonthDate');
            }
          }
        if(schedule.hasOwnProperty('days'))
          delete schedule.days;
        break;
    }
  }
  //checks for validation. return "null" means valid!
  return (isScheduleValid) ? null : err;
  }
}

@Component({
  selector: 'schedule-selector',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ScheduleSelector), multi: true },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => ScheduleSelector), multi: true },
    TranslateService
  ],
  styles: [require('./schedule-selector.scss')],
  template: require('./schedule-selector.html')
})

//ControlValueAccessor is the Interface to implement, if we have to create a custom form element
export class ScheduleSelector implements ControlValueAccessor, OnChanges {

  /* Implementation of ControlValueAccessor Interface */
  writeValue(value) {
    if (value) {
      this.schedule = value;
    }
  }

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched() {}

  propagateChange:any = () => {};
  validateFn:any = () => {};
  /* END - Implementation of ControlValueAccessor Interface */

  @Input('scheduleObject') _scheduleObject:any;
  @Input() mode: string;
  @Input('isVisible') isVisible: boolean;

  EDIT_MODE = 'edit';

  FREQUENCY_CONSTANTS = {
    "DAILY": "Daily",
    "WEEKLY": "Weekly",
    "MONTHLY": "Monthly",
    "YEARLY": "Yearly"
  };

  frequencyList = [
    {'value': this.FREQUENCY_CONSTANTS.DAILY, label: 'Daily'},
    {'value': this.FREQUENCY_CONSTANTS.WEEKLY, label: 'Weekly'},
    {'value': this.FREQUENCY_CONSTANTS.MONTHLY, label: 'Monthly'},
    {'value': this.FREQUENCY_CONSTANTS.YEARLY, label: 'Yearly'}
  ];

  daysList = [
    {'value':'Sunday', label: 'S', tootip: 'Every Sunday'},
    {'value':'Monday', label: 'M', tootip: 'Every Monday'},
    {'value':'Tuesday', label: 'T', tootip: 'Every Tuesday'},
    {'value':'Wednesday', label: 'W', tootip: 'Every Wednesday'},
    {'value':'Thursday', label: 'T', tootip: 'Every Thursday'},
    {'value':'Friday', label: 'F', tootip: 'Every Friday'},
    {'value':'Saturday', label: 'S', tootip: 'Every Saturday'}
  ];

  timeList = [
    {'value':'00:00:00', label: '00:00 Hrs'},{'value':'00:30:00', label: '00:30 Hrs'},{'value':'01:00:00', label: '01:00 Hrs'},
    {'value':'01:30:00', label: '01:30 Hrs'},{'value':'02:00:00', label: '02:00 Hrs'},{'value':'02:30:00', label: '02:30 Hrs'},
    {'value':'03:00:00', label: '03:00 Hrs'},{'value':'03:30:00', label: '03:30 Hrs'},{'value':'04:00:00', label: '04:00 Hrs'},
    {'value':'04:30:00', label: '04:30 Hrs'},{'value':'05:00:00', label: '05:00 Hrs'},{'value':'05:30:00', label: '05:30 Hrs'},
    {'value':'06:00:00', label: '06:00 Hrs'},{'value':'06:30:00', label: '06:30 Hrs'},{'value':'07:00:00', label: '07:00 Hrs'},
    {'value':'07:30:00', label: '07:30 Hrs'},{'value':'08:00:00', label: '08:00 Hrs'},{'value':'08:30:00', label: '08:30 Hrs'},
    {'value':'09:00:00', label: '09:00 Hrs'},{'value':'09:30:00', label: '09:30 Hrs'},{'value':'10:00:00', label: '10:00 Hrs'},
    {'value':'10:30:00', label: '10:30 Hrs'},{'value':'11:00:00', label: '11:00 Hrs'},{'value':'11:30:00', label: '11:30 Hrs'},
    {'value':'12:00:00', label: '12:00 Hrs'},{'value':'12:30:00', label: '12:30 Hrs'},{'value':'13:00:00', label: '13:00 Hrs'},
    {'value':'13:30:00', label: '13:30 Hrs'},{'value':'14:00:00', label: '14:00 Hrs'},{'value':'14:30:00', label: '14:30 Hrs'},
    {'value':'15:00:00', label: '15:00 Hrs'},{'value':'15:30:00', label: '15:30 Hrs'},{'value':'16:00:00', label: '16:00 Hrs'},
    {'value':'16:30:00', label: '16:30 Hrs'},{'value':'17:00:00', label: '17:00 Hrs'},{'value':'17:30:00', label: '17:30 Hrs'},
    {'value':'18:00:00', label: '18:00 Hrs'},{'value':'18:30:00', label: '18:30 Hrs'},{'value':'19:00:00', label: '19:00 Hrs'},
    {'value':'19:30:00', label: '19:30 Hrs'},{'value':'20:00:00', label: '20:00 Hrs'},{'value':'20:30:00', label: '20:30 Hrs'},
    {'value':'21:00:00', label: '21:00 Hrs'},{'value':'21:30:00', label: '21:30 Hrs'},{'value':'22:00:00', label: '22:00 Hrs'},
    {'value':'22:30:00', label: '22:30 Hrs'},{'value':'23:00:00', label: '23:00 Hrs'},{'value':'23:30:00', label: '23:30 Hrs'}
  ];

  monthsList = [
    {'value':'January', label: '01', tootip: 'January'},
    {'value':'February', label: '02', tootip: 'February'},
    {'value':'March', label: '03', tootip: 'March'},
    {'value':'April', label: '04', tootip: 'April'},
    {'value':'May', label: '05', tootip: 'May'},
    {'value':'June', label: '06', tootip: 'June'},
    {'value':'July', label: '07', tootip: 'July'},
    {'value':'August', label: '08', tootip: 'August'},
    {'value':'September', label: '09', tootip: 'September'},
    {'value':'October', label: '10', tootip: 'October'},
    {'value':'November', label: '11', tootip: 'November'},
    {'value':'December', label: '12', tootip: 'December'}
  ];

  dateList = [
    {'value':1, label: '01'},{'value':2, label: '02'},
    {'value':3, label: '03'},{'value':4, label: '04'},{'value':5, label: '05'},
    {'value':6, label: '06'},{'value':7, label: '07'},{'value':8, label: '08'},
    {'value':9, label: '09'},{'value':10, label: '10'},{'value':11, label: '11'},
    {'value':12, label: '12'},{'value':13, label: '13'},{'value':14, label: '14'},
    {'value':15, label: '15'},{'value':16, label: '16'},{'value':17, label: '17'},
    {'value':18, label: '18'},{'value':19, label: '19'},{'value':20, label: '20'},
    {'value':21, label: '21'},{'value':22, label: '22'},{'value':23, label: '23'},
    {'value':24, label: '24'},{'value':25, label: '25'},{'value':26, label: '26'},
    {'value':27, label: '27'},{'value':28, label: '28'},{'value':29, label: '29'},
    {'value':30, label: '30'},{'value':31, label: '31'}
  ];

  schedule: Object;
  selectedFrequency: Object;
  selectedDay: any;
  selectedTime: Object;
  selectedMonth: any;
  selectedDate: Object;
  alertObject: Object = {
    "isShown": false,
    "msg": "",
    "alertType": 'alert-danger'
  };

  constructor( private translateService: TranslateService ) {
    translateService.use(GlobalVariables.LOCALE);
  }

  fireChanges() {
    this.validateFn = scheduleValidator(this.schedule, this.FREQUENCY_CONSTANTS, this.alertObject, this.translateService);
    this.propagateChange(this.schedule);
  }

  validate(c: FormControl) {
    return this.validateFn(c);
  }

  ngOnChanges(changes) {
    if(changes.isVisible && changes.isVisible.hasOwnProperty('currentValue') && changes.isVisible.currentValue ) {
      this.setScheduleObject();
      //Fire changes only when the component is visible, else the outer form will not get the changes
      this.fireChanges();
    }
    else {
      //reset values
      this.reset();
    }
  }

  setScheduleObject() {
    this.reset();
    if(this._scheduleObject && typeof this._scheduleObject === 'object'
        && this._scheduleObject.hasOwnProperty('schedule') && this._scheduleObject.schedule ) {
        this.schedule = this._scheduleObject.schedule;
        if(this.schedule.hasOwnProperty('days'))
          setTimeout((d) => this.setDayCombo(d), 100, this.schedule['days']);
        if(this.schedule.hasOwnProperty('dates') && this.schedule['dates'].constructor === Array && this.schedule['dates'].length > 0 )
          setTimeout((d) => this.setDateCombo(d), 100, Number(this.schedule['dates'][0]));
        if(this.schedule.hasOwnProperty('months'))
          setTimeout((m) => this.setMonthCombo(m), 100, this.schedule['months']);
        if(this.schedule.hasOwnProperty('scheduleType'))
          setTimeout((st) => this.setFrequencyCombo(st), 100, this.schedule['scheduleType']);
        if(this.schedule.hasOwnProperty('startTime'))
          setTimeout((st) => this.schedule['startTime'] = st, 100, this.schedule['startTime']);
    }
  }

  reset() {
    this.schedule = {
        "startTime" : "00:00:00",
        "timeZone" : "America/Los_Angeles",
        "timeOfDays" : [ {
        "hour" : 0,
        "minutes" : 0,
        "seconds" : 0
        } ],
        "scheduleType" : this.FREQUENCY_CONSTANTS.DAILY
    }
    this.setFrequencyCombo(this.FREQUENCY_CONSTANTS.DAILY);
    this.setDayCombo(["Sunday"]);
    this.setDateCombo(1);
    this.setMonthCombo(["January"]);
  }

  //Combo box pre-selection
  setFrequencyCombo(value) {
    this.selectedFrequency = value;
  }

  setDayCombo(value) {
    this.selectedDay = value;
  }

  setDateCombo(value) {
    this.selectedDate = value;
  }

  setMonthCombo(value) {
    this.selectedMonth = value;
  }


  //Event handlers from view
  onFrequencyChange(val) {
    this.selectedFrequency = val;
    this.schedule['scheduleType'] = val;
    this.schedule['startTime'] = "00:00:00";

    switch(val){
      case this.FREQUENCY_CONSTANTS.WEEKLY:
        this.setDayCombo(["Sunday"]);
        this.onDayChange(["Sunday"]);
        break;
      case this.FREQUENCY_CONSTANTS.MONTHLY:
        this.setDateCombo(1);
        this.onDateChange(1);
        break;
      case this.FREQUENCY_CONSTANTS.YEARLY:
        this.setDateCombo(1);
        this.onDateChange(1);
        this.setMonthCombo(["January"]);
        this.onMonthChange(["January"]);
        break;
    }
    this.fireChanges();
  }

  validateChanges() {
    return false;
  }

  onDayChange(val) {
    this.selectedDay = val;
    this.schedule['days'] = val;
    this.fireChanges();
  }

  onDateChange(val) {
    var daysOfMonth = [];
    this.selectedDate = val;
    this.schedule['dates'] = []; //[Number(val)];
    daysOfMonth = (val && _.trim(val) != "") ? _.split(val, ",") : [];
    for(let x = 0; x < daysOfMonth.length; x++) {
      this.schedule['dates'].push( Number(daysOfMonth[x]) );
    }
    this.fireChanges();
  }

  onMonthChange(val) {
    this.selectedMonth = val;
    this.schedule['months'] = val;
    this.fireChanges();
  }

  onTimeChange(event) {
    if(event && event.value) {
      this.schedule['startTime'] = event.value;
      this.fireChanges();
    }
  }

  onTimezoneChange(event) {
    if(event && event.value) {
      this.schedule['timeZone'] = event.value;
      this.fireChanges();
    }
  }

  checkIfMonthSelected(month) {
    if (month && month.value && this.selectedMonth && _.includes(this.selectedMonth, month.value)) {
      return true;
    }else{
      return false;
    }
  }
  onMonthCheckboxClick(event, month) {
    if ( event && event.target ) {
      if ( event.target.checked ) {
        if ( month && !_.includes(this.selectedMonth, month) ) {
          this.selectedMonth.push(month);
        }
      }else{
        if ( month && _.includes(this.selectedMonth, month) ) {
          this.selectedMonth = _.remove(this.selectedMonth, function(m) { return m !== month; });
        }
      }
      this.onMonthChange( this.selectedMonth );
    }
  }
  checkIfWeekSelected(day) {
    if (day && day.value && this.selectedDay && _.includes(this.selectedDay, day.value)) {
      return true;
    }else{
      return false;
    }
  }
  onWeekCheckboxClick(event, day) {
    if ( event && event.target ) {
      if ( event.target.checked ) {
        if ( day && !_.includes(this.selectedDay, day) ) {
          this.selectedDay.push(day);
        }
      }else{
        if ( day && _.includes(this.selectedDay, day) ) {
          this.selectedDay = _.remove(this.selectedDay, function(m) { return m !== day; });
        }
      }
      this.onDayChange( this.selectedDay );
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-common/schedule-selector/schedule-selector.component.ts